import { Component, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-tick-snackbar',
  standalone: true,
  imports: [
    MatIconModule
  ],
  templateUrl: './tick-snackbar.component.html',
  styleUrl: './tick-snackbar.component.scss'
})
export class TickSnackbarComponent {

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {}
}
